// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiEndpoint: 'http://localhost:5000',
  /**
   * Optional override for Chronodesk WhatsApp API when appsettings `Connections.whatsappApiEndPoint` is not set.
   * Prefer configuring ClientApp `src/appsettings.json` for deployments.
   */
  whatsappApiEndpoint: undefined as string | undefined,
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
